import React, { useState, useRef } from 'react';
import { connect } from 'umi';

import {
  Layout,
  Text,
  Button,
} from "tea-component";
import SvgIcon from '@/pages/home/components/SvgIcon';
import DbComponent from '@/pages/dashboard/components/DbComponent/DbCompontent';
import { useLocal, useTimeZone } from '@/pages/dashboard/utils/customHook';
import { DbComponentItemType } from '@/pages/dashboard/types/dashboard';

const { Content } = Layout;

const componentList: DbComponentItemType[] = [
  {
    name: 'realtime_revenue',
    filterType: 'common'
  }
];

const Revenue = (props: any) => {
  const { gameCode } = props;
  const { locale, getLocalText } = useLocal('realtime_revenue')
  const { timeZoneText, timeZone } = useTimeZone(gameCode, getLocalText)

  return (
    <Content >
      <Content.Header
        title={getLocalText('title')}
        subtitle={
          <Text theme="label">{timeZoneText}</Text>
        }
        operation={<Button className='ns-btn--border btn-top' > <SvgIcon className='btn-top-icon' type="refresh" />刷新</Button>}
      >
      </Content.Header>
      <Content.Body full >
        <DbComponent list={componentList} />
      </Content.Body>
    </Content>
  );
};

export default connect((state: any) => {
  return {
    gameCode: state.dashboard?.currentGame?.game_code,
    notices: state.dashboard?.notices,
  }
})(Revenue)
